interface AddressFields {
  streetAddress1?: string;
  streetAddress2?: string;
  city?: string;
  county?: string;
  postcode?: string;
}

/** Single-line address, e.g. "14 Brae Street, Edinburgh, Midlothian, EH3 6HR". */
export const formatAddress = (address: AddressFields): string =>
  [address.streetAddress1, address.city, address.county, address.postcode]
    .filter(Boolean)
    .join(', ');
